var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn_add"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 27",
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#FFFCF2",
    stroke: "#FCCA00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 3256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 219",
    d: "M8 12H16",
    stroke: "#FCCA00",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 220",
    d: "M12 16L12 8",
    stroke: "#FCCA00",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAdd);
export default __webpack_public_path__ + "static/media/btn_add.72778a263818b6b1f2ada745aa3c35a8.svg";
export { ForwardRef as ReactComponent };